import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, TextField } from '@mui/material';
import { Title } from '../../../../components/atoms/title';

export const SearchUser = () => {
  const navigate = useNavigate();
  const [consultedUserEmail, setConsultedUserEmail] = useState('');

  const handleGetConsultedUserData = async e => {
    e.preventDefault();
    navigate(`/issue-details/user/${consultedUserEmail}`);
  };

  return (
    <form action='' onSubmit={handleGetConsultedUserData}>
      <Grid container spacing={2}>
        <Grid item>
          <Title>Buscar usuário</Title>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label='E-mail'
            placeholder='bob@bob.bob'
            fullWidth
            variant='outlined'
            onChange={e => setConsultedUserEmail(e.target.value)}
            value={consultedUserEmail}
          />
        </Grid>
        <Grid container spacing={1} item>
          <Box m='auto' mt={3}>
            <Button onClick={handleGetConsultedUserData} variant='contained' color='primary' type='submit'>
              Procurar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};
